module.exports = __webpack_public_path__ + "static/scale-model-of-morris-murdock-travel-of-orem-in-provo-utah-ea5317ef9699d986ac67490615986dd0.png";